import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Education.css";

const Education = () => {
  AOS.init();
  
  const educationData = [
    {
      degree: "Bachelor of Technology (B.Tech)",
      field: "Computer Science & Engineering",
      institution: "DR. A. P. J. Abdul Kalam Technical University",
      location: "Aligarh, Uttar Pradesh",
      period: "Jun 2016 – Jun 2020",
      icon: "🎓",
      color: "primary"
    },
    {
      degree: "Full Stack Web Development Program",
      field: "Web Development",
      institution: "MASAI School",
      location: "Bengaluru",
      period: "Dec 2020 – May 2021",
      icon: "💻",
      color: "secondary"
    }
  ];

  return (
    <div className="education-container">
      <h1>Education</h1>
      <div className="education-grid">
        {educationData.map((edu, index) => (
          <div
            key={index}
            data-aos="flip-up"
            data-aos-offset="10"
            data-aos-delay={50 * index}
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            className={`education-card ${edu.color}`}
          >
            <div className="education-icon-wrapper">
              <span className="education-icon">{edu.icon}</span>
            </div>
            
            <div className="education-content">
              <h2 className="degree">{edu.degree}</h2>
              <h3 className="field">{edu.field}</h3>
              
              <div className="institution-info">
                <div className="institution-name">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" fill="currentColor"/>
                  </svg>
                  <span>{edu.institution}</span>
                </div>
                
                <div className="education-meta">
                  <span className="location">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
                    </svg>
                    {edu.location}
                  </span>
                  
                  <span className="period">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="currentColor"/>
                    </svg>
                    {edu.period}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="card-shine"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;

